export { default } from "./BaseDuration.vue";
